export default "__VITE_ASSET__BdaH9KJB__"